<template>
<div style="width:100%;padding:0px;" class="display-flex" @click="$emit('focus', $event)">
    <div v-if="question" style="padding-right:8px;flex-grow:1" :class="{'no-label-question': !label}">
        <div class="element-label">{{label}}</div>
        {{question}}
    </div>
    <div>
        <div v-if="!question" class="element-label">{{label}}</div>
        <div class="yesno-container" :class="{yes: value=='Yes', 'no-value': !value}" @click="buttonClicked" @dblclick="setValue(null)">

            <div class="yesno-slot" :class="slotClass">
            
            </div>

            <div class="yesno-button" :class="buttonClass">
                <div v-if="!value" class="display-flex">
                    <div @click.stop="setValue('No')" style="padding:9px;text-align:center;flex-grow:1;border-right:solid 1px #ddd;border-top-left-radius:14px;border-bottom-left-radius:14px;" class="hoverable">NO</div>
                    <div @click.stop="setValue('Yes')" style="padding:9px;text-align:center;flex-grow:1;border-top-right-radius:14px;border-bottom-right-radius:14px;" class="hoverable">YES</div>
                </div>
                <div v-else style="padding:5px;">
                    {{value}}
                </div>
            </div>

        </div>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
        
        }
    },
    
    props: {
        label: String,
        question: String,
        value: String,
        color: String,
    },

    computed: {
        extraSmall() {
            return this.$vuetify.breakpoint.name == 'xs'
        },
        slotClass() {
          
            const classObj = {
                'yes': this.value == 'Yes',
                'grey-text': !this.color || this.value == 'No',
                'white-text': this.color && this.value == 'Yes', 
            }
            classObj[this.color] = Boolean(this.color) && this.value == 'Yes'
            return classObj
        },
        buttonClass() {

            const isColoured = Boolean(this.color) && this.value == 'Yes'
          
            const classObj = {
                'yes': this.value == 'Yes',
                'grey--text': !this.color || this.value == 'No',
                'white--text': this.color && this.value == 'Yes', 
                'white': !this.isColoured,
                'no-value': !this.value,
            }
            
            classObj[this.color] = isColoured

            return classObj
        }
    },

    methods: {
        buttonClicked() {
            const newValue = (this.value == 'Yes' ? 'No' : 'Yes')
            this.setValue(newValue)
        },

        setValue(newValue) {
            this.$emit('input', newValue)
        },


    }
}
</script>

<style scoped>


.yesno-container {
    margin-top:10px;
    position:relative;width:50px;
    height:40px;
    min-width:50px;
}
.yesno-container.no-value {
    width:120px;
    min-width:120px;
}
.yesno-slot {
    position:absolute;border-radius:999px;width:100%;top:8px;
    height:18px;
    background-color:#aaa;
    opacity:0.6;
    width:48px;
}
.yesno-button {
    text-transform:uppercase; position:absolute;top:3px; left:0px;
    font-weight:500;font-size:12px;
    height:28px; width:38px;
    border-radius:20px;text-align:center;
    box-shadow: 2px 2px 6px 0px rgba(0,0,0,0.3);
    user-select: none; cursor: pointer;
    transition: all .3s ease-in-out;
    opacity: 1;
}

.yesno-button.no-value {
    width:120px;
    height: 36px;
    top:0px;
}

.yesno-container:hover .yesno-button {
    box-shadow: 0px 0px 0px 10px rgba(0,0,0,0.08);
}

.yes.yesno-button {
    left:12px;
}
.no-label-question {
    padding-top:5px;
}
   
</style>




// WEBPACK FOOTER //
// YesNo.vue?0d475ff7